import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
const { Item } = Form;
import theme from "styles/theme";

export const FirstLine = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
`;

export const SecondLine = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 0px;
`;

export const FormItemFieldName = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-form-item-control {
    width: 100%;
  }

  .ant-form-item-label {
    display: flex !important;
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    height: 33px !important;
    z-index: 1;
    pointer-events: none !important;
    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
    }
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-input {
    box-shadow: none;
    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }
`;

export const FormItem = styled(Item)`
  .ant-form-item-control {
    width: 100%;
  }

  .ant-input {
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }

  .ant-form-item-label {
    display: flex !important;
    min-width: 100%;
    max-width: 100%;
    height: 33px !important;
    padding: 3px 0;
    z-index: 1;
    pointer-events: none !important;
    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
    }
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1px solid ${(props) => props.theme.colors.manatee};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }
`;

export const DescriptionField: CSSProperties = {
  width: "100%",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const RequiredDescriptionField: CSSProperties = {
  width: "100%",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const DescriptionActiveLocation: CSSProperties = {
  marginLeft: "10px",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const ContainerLocationActive = styled.div`
  display: grid;
  grid-template-columns: 0.94fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  margin-top: 10px;
  div {
    display: flex;
    margin-right: auto;
    margin-bottom: 10px;
    > btn {
      margin-right: 8px;
    }
  }
`;

export const InputField: CSSProperties = {
  height: theme["@height-input-lg"],
};

export const InputAddressState: CSSProperties = {
  height: theme["@height-input-lg"],
  textTransform: "uppercase",
};

export const SpaceSwitchCheckin: CSSProperties = {
  marginTop: "-5px",
};
